import React,{useEffect, useState} from 'react';
import ArrowIcon from '../assets/img/arrow_back.svg';
import {ChakraProvider, theme, Button, Text, Flex, Image, Box,NumberInput ,NumberInputField,Tooltip} from "@chakra-ui/react";
import CameraCard from './CameraCard';
import { login } from '../apis/User';
import { useHistory } from 'react-router';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { registerAndAddPhotoToCart } from '../apis/Cart';

const OtpCard = (props) =>{  
  const history = useHistory();
  const [otp, SetOtp] = useState(null);
  const [showToolTipOtp, setShowToolTipOtp] = useState(false); 
  const [errorMsg, seterrorMsg] = useState('Please Enter 4 digit otp');
  let timer = 15; // second timer
  const [timeLeft, setTimeLeft] = useState(timer);
  const [showLandingPage, SetLandingPage] = useState(false);
  const [showLoading, SetLoading] = useState(false);
  const toggleAuth = useStoreActions( store => store.toggleAuth)
  const handleUserProfile = useStoreActions( store => store.handleUserProfile);
  const isUserLogged = useStoreState( state => state.isUserLogged)
  const tempUser = useStoreState( state => state.tempUser)

  const comingFromCartPage = () => {
      registerAndAddPhotoToCart(props.eventId, tempUser.selfi_url, props.PhoneNo, otp, props.userCountry, 1, props.cart, props.price ).then(resp => {
        if(resp.error){
          alert(resp.message)
        }else{
          toggleAuth(true);
          handleUserProfile(resp.data[0])
          localStorage.setItem('user-login-status', true);
          localStorage.setItem('memzo-auth-token', JSON.stringify(resp.data[0]?.api_key))
          setTimeout( () => { 
            (Boolean(props.redirectUrl)) ? history.replace(props.redirectUrl) : history.replace(`${process.env.PUBLIC_URL}/events`);
          }, 0);
        }
      })
  }
  const LandingPageBtn = () =>{
    if(otp !== null){
      SetLoading(true);
      if(Number(otp?.length) !== 4 )
      {
        seterrorMsg('Please Enter 4 digits otp'); 
        SetLoading(false);
      return setShowToolTipOtp(true); 
      }
    (!!isUserLogged) ? comingFromCartPage()
    : login(props.PhoneNo, props.userCountry, otp).then(resp => {

      if(resp.error){
        setShowToolTipOtp(true);
        SetLoading(false);
        seterrorMsg(resp.message);
      }else{
        SetLoading(false);
        toggleAuth(true);
        handleUserProfile(resp.data[0])
        localStorage.setItem('user-login-status', true);
        localStorage.setItem('memzo-auth-token', JSON.stringify(resp.data[0]?.api_key))
        setTimeout( () => { 
          (Boolean(props.redirectUrl)) ? history.replace(props.redirectUrl) : history.replace(`${process.env.PUBLIC_URL}/events`);
        }, 0);
      }

    }).catch(error => {
      console.log("rr",error)
    })
  }else{
    setShowToolTipOtp(true);
    SetLoading(false);
    seterrorMsg("Please Enter 4 digit otp");
  }
  }
  
  const handelChange = (e) =>{
    SetOtp(e);    
  }

  useEffect( () => {
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
        setTimeLeft((t) => t - 1);
        }, 1000)
      return () => clearInterval(intervalId);
  },[timeLeft])

    return(
      <ChakraProvider theme={theme}>
          <Flex alignItems="center" justifyContent="space-between">
          <Box pt="6" pb="4" pl="4">
          <Image 
            src={ArrowIcon}
            alt="Arrow Icon"
            w="20px" 
            h="20px"
            onClick={() => props.ShowOtpCard(false)}
            />
          </Box>
          </Flex>
  
          <Flex
          flexDirection="column"
          pt="8"
          pl="5"
          pr="4">
          <Text
          color="#222222"
          fontWeight="700"
          fontSize="24px">
            OTP Verification
          </Text>
          <Text
          pt="4"
          color="#666666"
          fontWeight="400"
          fontSize="15px">
            Enter 4 digit code sent to +91-{props.PhoneNo}
          </Text>
          </Flex>
          
          <Flex>
          <NumberInput
            mt="8"
            pl="4"
            pr="4"
            max={6}
            keepWithinRange={false}
            clampValueOnBlur={false}
            w="100%"
            focusBorderColor="#E0E0E0"
            onChange={(e) => handelChange(e)}
            >
          <NumberInputField 
           className='ps-desktop-width-auto'
          height="50px"
          placeholder="Enter code"
          borderColor="#E0E0E0 !important"
          boxShadow="none !important"
          onClick={() =>setShowToolTipOtp(false)}/>
          </NumberInput>
          </Flex>
          {showToolTipOtp && <Tooltip label={errorMsg} placement="top" isOpen mt="-70px" ml="12px"> </Tooltip>}
  
          <Flex flexDirection="column">
          { (timeLeft) ? <Flex pt="8" pl="5" alignItems="center">
            <Text
            fontSize="13px"
            fontWeight="400"
            color="#786d6d">
              Resend OTP in 
            </Text>
            <Text
            pl="2"
            fontSize="13px"
            fontWeight="700"
            color="#FA2F45">
              {timeLeft} secs
            </Text>
            </Flex> : null}
  
            { !timeLeft ? <Flex pt="4" pl="5" alignItems="center">
            <Text            
            fontSize="13px"
            fontWeight="400"
            color="#786d6d">
              Resend Code via
            </Text>
            <Button
            colorScheme="" variant="ghost" p="0"
            onClick={e => props.handleOTP()}
            >
            <Text
            className='ps-btn-hover-shaded'
            pr="1"
            pl="2"
            fontSize="13px"
            fontWeight="700"
            color="#FA2F45"
            textDecoration="underline">
              SMS
            </Text>
            </Button>
            <Text
            fontSize="13px"
            fontWeight="700"
            color="#FA2F45">/</Text>
            <Button 
            colorScheme="" variant="ghost" p="0"
            onClick={e => props.handleOTP(1)}
            >
            <Text
            className='ps-btn-hover-shaded'
            pl="1"
            fontSize="13px"
            fontWeight="700"
            color="#FA2F45"
            textDecoration="underline">
              Whatsapp
            </Text>
            </Button>
            </Flex> : null}
          </Flex>
  
          <Button
          className='ps-btn-hover-shaded-bg ps-desktop-width-200'
          mt="16"
          ml="5"
          color="white"
          bg="#FA2F45"         
          h="12"
          pl="8"
          pr="8"
          isLoading={showLoading}
          loadingText="Continue"
          colorScheme="#FA2F45"
          fontWeight="700"
          fontSize="15px"
          borderRadius="40"
          onClick={() => LandingPageBtn(true)}>
          Continue
          </Button>
          
        {showLandingPage &&
          <CameraCard/>
        }
    </ChakraProvider>
  )}

export default OtpCard;